import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FeedbackDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  feedbackText: string;
  onFeedbackChange: (text: string) => void;
}

const FeedbackDialog: React.FC<FeedbackDialogProps> = ({
  open,
  onClose,
  onSubmit,
  feedbackText,
  onFeedbackChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        Provide Lead's feedback
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Give feedback about lead's scoring / evaluation as per the expectations
          set by you
        </Typography>
        <Typography sx={{ fontWeight: 500, mb: 1 }}>
          Introduction<span style={{ color: 'red' }}>*</span>
        </Typography>
        <TextField
          placeholder="Write a brief feedback about the lead"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={feedbackText}
          onChange={(e) => onFeedbackChange(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            background: '#FAFAFA',
            border: '1px solid #D1D5DB',
            color: '#111827',
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{ border: '1px solid #111827', background: '#325CD6' }}
          variant="contained"
          onClick={onSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog; 